import React from 'react';
import { Loader2 } from 'lucide-react';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogCancel,
} from '../components/ui/AlertDialog';
import { Button } from '../components/ui/Button';

interface RollbackConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  targetVersion: number;
  playbookName: string;
  onConfirm: () => void;
  isRollingBack: boolean;
}

const RollbackConfirmDialog: React.FC<RollbackConfirmDialogProps> = ({
  open,
  onOpenChange,
  targetVersion,
  playbookName,
  onConfirm,
  isRollingBack,
}) => {
  const handleConfirm = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    onConfirm();
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Rollback to Version {targetVersion}?</AlertDialogTitle>
          <AlertDialogDescription className="space-y-3">
            <p>
              This will restore content from Version {targetVersion} and publish it as a new version.
              History is preserved.
            </p>
            <p className="text-sm text-orange-600 font-medium">
              The current playbook content will be replaced with the snapshot from Version {targetVersion}.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isRollingBack}>
            Cancel
          </AlertDialogCancel>
          <Button
            onClick={handleConfirm}
            disabled={isRollingBack}
            className="bg-orange-500 hover:bg-orange-600 text-white"
          >
            {isRollingBack ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Rolling back...
              </>
            ) : (
              <>Rollback to Version {targetVersion}</>
            )}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default RollbackConfirmDialog;
